// src/services/flexi.service.js
import { api } from './api';

class FlexiRequestService {
    /**
     * Create a new flexi component request (Employee)
     */
    async createRequest(requestData) {
        try {
            const response = await api.post('/api/flexi-requests', requestData);
            return response.data;
        } catch (error) {
            console.error('Error creating flexi request:', error);
            throw error;
        }
    }

    /**
     * Get employee's own flexi requests
     */
    async getMyRequests() {
        try {
            const response = await api.get('/api/flexi-requests/my-requests');
            return response.data;
        } catch (error) {
            console.error('Error fetching my flexi requests:', error);
            throw error;
        }
    }

    /**
     * Get team flexi requests (Manager)
     */
    async getTeamRequests() {
        try {
            const response = await api.get('/api/flexi-requests/team');
            return response.data;
        } catch (error) {
            console.error('Error fetching team flexi requests:', error);
            throw error;
        }
    }

    /**
     * Get all flexi requests (Admin)
     */
    async getAllRequests() {
        try {
            const response = await api.get('/api/flexi-requests/all');
            return response.data;
        } catch (error) {
            console.error('Error fetching all flexi requests:', error);
            throw error;
        }
    }

    /**
     * Approve flexi request (Manager/Admin)
     */
    async approveRequest(requestId, comments = '') {
        try {
            const response = await api.post(`/api/flexi-requests/${requestId}/approve`, {
                comments
            });
            return response.data;
        } catch (error) {
            console.error('Error approving flexi request:', error);
            throw error;
        }
    }

    /**
     * Reject flexi request (Manager/Admin)
     */
    async rejectRequest(requestId, reason, comments = '') {
        try {
            const response = await api.post(`/api/flexi-requests/${requestId}/reject`, {
                reason,
                comments
            });
            return response.data;
        } catch (error) {
            console.error('Error rejecting flexi request:', error);
            throw error;
        }
    }

    /**
     * Cancel flexi request (Employee)
     */
    async cancelRequest(requestId, reason = '') {
        try {
            const response = await api.post(`/api/flexi-requests/${requestId}/cancel`, {
                reason
            });
            return response.data;
        } catch (error) {
            console.error('Error cancelling flexi request:', error);
            throw error;
        }
    }

    /**
     * Update flexi request status (Admin)
     */
    async updateRequestStatus(requestId, status, comments = '') {
        try {
            const response = await api.put(`/api/flexi-requests/${requestId}/status`, {
                status,
                comments
            });
            return response.data;
        } catch (error) {
            console.error('Error updating flexi request status:', error);
            throw error;
        }
    }
}

export default new FlexiRequestService();
